<div class="alert-container">
  <mat-icon class="alert-icon">warning_outline</mat-icon>
  <p class="alert-message">{{ message() }}</p>
</div>
